module.exports = __webpack_public_path__ + "static/media/n4.28f88178.png";